import 'components/units/UnitDefinitionsAndMasks';
import { unit } from 'mathjs';
import hasValue from './hasValue';

export const toLiters = (raw, rawUnit) => {
  if (!hasValue(raw) || !['number', 'string'].includes(typeof raw)) return null;
  const value = Number(raw);
  if (!Number.isFinite(value) || value < 0) return null;
  try {
    const liters = unit(value, rawUnit).toNumber('L');
    return Number.isFinite(liters) ? liters : null;
  } catch (_) {
    return null;
  }
};

// Ignore floating-point conversion noise only: a volume equal to the capacity is valid.
const exceeds = (volume, capacity) => volume - capacity > 1e-9 * Math.max(1, volume, capacity);

// Capacity a volume exceeds: the total capacity first, then the usable capacity
// within the total. Volume and capacities are { value, unit }; a missing or zero
// capacity is not checked. Shared by the operator form and the admin issues.
export default function exceededCapacity(volume, { totalCapacity, usableCapacity }) {
  const liters = toLiters(volume?.value, volume?.unit);
  if (liters === null) return null;
  const isExceeded = (capacity) => {
    const capacityLiters = capacity ? toLiters(capacity.value, capacity.unit) : null;
    return Boolean(capacityLiters) && exceeds(liters, capacityLiters);
  };
  if (isExceeded(totalCapacity)) return 'totalCapacity';
  if (isExceeded(usableCapacity)) return 'usableCapacity';
  return null;
}
